import getRequest from '../../../getRequest';

/**
 *
 * @param {number} currentPage
 * @param {number} itemsPerPage
 * @param {string} search
 * @returns {AxiosResponse}
 *m
 */
const getUserActivityLogs = async (currentPage, itemsPerPage, search) => {
  const paginationUrl = `&page=${currentPage}&size=${itemsPerPage}`;
  const endpoint = `/users-management/user-management-logs?search=${search === undefined ? '' : search}&${paginationUrl}`;

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get User Activity Logs')
      .then((response) => resolve(response))
      .catch((error) => {
        reject(error instanceof Error ? error : new Error(error));
      });
  });
};
export default getUserActivityLogs;
